module.exports = __webpack_public_path__ + "b4b49e509faa6043a3a6b1301551f27d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_twitter_colour.svg
// module id = ir0y
// module chunks = 5